// @/utils/pdfQuotationGenerator.js

/**
 * PDF Quotation Generator — Dispatcher
 *
 * รักษา public API เดิม (exportToPDF) ไว้ให้เหมือนเดิมทุกประการ เพื่อไม่ต้องแก้โค้ด
 * ที่เรียกใช้อยู่แล้ว (เช่น import pdfQuotationGenerator from "@/utils/pdfQuotationGenerator";
 * pdfQuotationGenerator.exportToPDF(data)) แต่ภายในแยกการสร้าง docDefinition ออกเป็น
 * 2 generator ตามประเภทเอกสาร:
 *
 *   - doc_type === "fixed"    -> PDFQuotationFixedGenerator    (หน้าแรก: Sub Total/VAT/Grand Total)
 *   - doc_type === "estimate" -> PDFQuotationEstimateGenerator (หน้าที่ 2: Estimated Professional Fees)
 */
import PDFQuotationFixedGenerator from "./pdfQuotationFixedGenerator";
import PDFQuotationEstimateGenerator from "./pdfQuotationEstimateGenerator";

class PDFQuotationGenerator {
    constructor() {
        this.fixedGenerator = new PDFQuotationFixedGenerator();
        this.estimateGenerator = new PDFQuotationEstimateGenerator();
    }

    /**
     * ฟังก์ชันหลักสำหรับ Export PDF — เลือก generator ตาม header.doc_type แล้วเปิด PDF ใหม่ในแท็บใหม่
     * @param {Object} quotationData - ข้อมูลใบเสนอราคาที่ต้องการ Export ({ header, items })
     * @returns {Promise<boolean>}
     */
    async exportToPDF(quotationData) {
        try {
              const generator = this.pickGenerator(quotationData);

              // รอให้ pdfMake พร้อมใช้งาน
              await generator.waitForPdfMakeReady();

              // สร้าง PDF
              const docDefinition = generator.generateDocDefinition(
                quotationData,
              );

              // เปิด PDF ใหม่ในแท็บใหม่
              //ฟังก์ชันปริ้นเก่า
            // pdfMake.createPdf(docDefinition).open();
            // return true;
            
              //ฟังก์ชันปริ้นใหม่
              return await new Promise((resolve, reject) => {
                try {
                  pdfMake.createPdf(docDefinition).getBlob(resolve);
                } catch (e) {
                  reject(e);
                }
              });

              
            } catch (error) {
            console.error("❌ เกิดข้อผิดพลาดในการสร้าง PDF:", error);
            throw error;
        }
    }

    pickGenerator(quotationData) {
        const isEstimate = quotationData?.header?.doc_type === "estimate";
        return isEstimate ? this.estimateGenerator : this.fixedGenerator;
    }
}

// Export instance (เหมือนเดิม)
export default new PDFQuotationGenerator();